import React from "react";
import { Box, Typography } from "@mui/material";
import { CustomCheckbox } from "@ippon/shared-components";

interface Props {
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
}

/**
 * shared-components の CustomCheckbox は icon のみで label を持たないので、
 * Unit セクション群で使う簡易ラベル付きチェックボックス。
 */
const LabeledCheckbox: React.FC<Props> = ({ label, checked, onChange }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      cursor: "pointer",
      mb: 1,
    }}
    onClick={() => onChange(!checked)}
  >
    <CustomCheckbox checked={checked} onChange={() => onChange(!checked)} />
    <Typography sx={{ fontSize: 13 }}>{label}</Typography>
  </Box>
);

export default LabeledCheckbox;
